import { createContext, ReactNode, useState } from 'react';

type ModalMenuContextType = {
  selectedMenuKey: string;
  setSelectedMenuKey: (menuKey: string) => void;
};

export const ModalMenuContext = createContext<ModalMenuContextType | null>(
  null
);

export type ModalMenuProviderProps = {
  defaultKey: string;
  children: ReactNode;
};

export const ModalMenuProvider = ({
  children,
  defaultKey,
}: ModalMenuProviderProps) => {
  const [selectedMenuKey, setSelectedMenuKey] = useState(defaultKey);

  return (
    <ModalMenuContext.Provider
      value={{
        selectedMenuKey,
        setSelectedMenuKey,
      }}
    >
      {children}
    </ModalMenuContext.Provider>
  );
};
